import React, { useEffect, useState } from "react";
import {HtmlParse} from 'utils';
import PropTypes from "prop-types";
import jumbitoA from 'images/jumbito/jumbito-phone-1.svg';
import jumbitoB from 'images/jumbito/jumbito-phone-2.svg';
import PubSub from 'services/PubSub/';
import { consumer } from 'config/constants';
import style from './style.scss'; //NOSONAR
import Loader from "components/Loader";


const UpdatePhone = (props) => {
    const [phoneMask, setPhoneMask] = useState('');
    const [phone, setPhone] = useState(props.phone);
    const [success, setSuccess] = useState(false);
    const [phoneValid, setValid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showJumbitoImg, setshowJumbitoImg] = useState(false);
    const callbackServices = props.callbackServices ? props.callbackServices : ()=>{};
    let settings = props.settings ? props.settings : { 
        title: '¡Hola!', 
        subtitle: 'Necesitamos actualizar tu teléfono', 
        btnSave: 'Continuar', 
        btnCancel: 'Actualizar más tarde',
    };
    
    useEffect(() => {
        validateConsumer();
        let oldPhone = props.phone;

        if(oldPhone && oldPhone.indexOf('+56') === 0){
            oldPhone = oldPhone.replace('+56','');
        }
        _onChangePhone(oldPhone ? oldPhone : '');
    }, [props.phone]);
    
    const sendNumber = () => {
        callbackServices(phone);
        setSuccess(true);

        if(settings.disabled && settings.disabled.logo === true) {
            setSuccess(false);
            setLoading(true);
        }
    };

    const onKeyPressInput = (val,ev) => {
        let number = null;

        if (!(/^[0-9]/.test(val))) {
            number = phoneMask.replace(val,'');
            setPhoneMask(number);
            validateNumber(number)
        }
        ev.preventDefault();
    };

    const validateNumber = (number) => {
        let numberMask = number.replace(/ /g, '');

        let valid = (!/[0]{9}|[1]{9}|[2]{9}|[3]{9}|[4]{9}|[5]{9}|[6]{9}|[7]{9}|[8]{9}|[9]{9}/.test(numberMask));

        if ((numberMask.length === 9) && (valid)) {
            setValid(true);
            setPhone(numberMask);
        } else {
            setValid(false);
        }
    };

    const _onChangePhone = (value) => {
        let number = value;

        number = number ? number.replace(/ /g,'') : '';
        let newChar = number[number.length - 1];

        if (!(/^[0-9]/.test(newChar))) {
            number = number.slice(0, number.length - 1);
        }

        if ((number.length) && (number.length < 10 && number.length > 3)) {
            number = number.slice(0, 1) + ' ' + number.slice(1);
        }
        validateNumber(number);
        setPhoneMask(number);
    };

    const _saveAfter = () => {
        PubSub.dispatch('update_phone_user', {
            results: {value: true}
        });
    };

    const _pasteEvent = (e) => {
        e.preventDefault();
        return null;
    };

    const validateConsumer = () => {
        if (consumer.includes('santaisabel')){
            setshowJumbitoImg(false)
        } else {
            setshowJumbitoImg(true)
        }
    }

    return <div className="update-phone-wrap" >
        {!success && <h2 className="update-phone-title">{settings.title}</h2>}
        {!success && <h4 className="update-phone-subtitle">{settings.subtitle}</h4>}

        {!success && !(settings.disabled && settings.disabled.logo) && showJumbitoImg &&<span className="update-phone-jumbito">{HtmlParse(jumbitoA)}</span>}
        {success && <span className="update-phone-jumbito">{HtmlParse(jumbitoB)}</span>}

        {!success && <span className="update-phone-msg">Actualiza tu número para continuar con tu pedido.</span>}

        {success && !(settings.disabled && settings.disabled.logo) && <span className="update-phone-success">¡Gracias!</span>}
        {!success && <div className="update-phone-wrap-phone">
            <input className="update-phone-cod-country" value={'+56'} readOnly/>
            <input type="tel" className="update-phone-number" onPaste={_pasteEvent} maxLength="10" placeholder="9 24871274" value={phoneMask} onChange={ev => _onChangePhone(ev.target.value)} onBlur={ev => _onChangePhone(ev.target.value)} onKeyUp={val => onKeyPressInput(val.key, val)} />
        </div>}
        {!success && <button className={"disabled-btn update-phone-button" + (phoneValid ? ' is-valid' : '')} onClick={sendNumber}>
            {!loading && <div className="update-phone-button-save">
                {settings.btnSave}
            </div>}

            {loading && <div className="update-phone-loading">
                <Loader />
            </div>}
        </button>}
        {!success && <a className="update-phone-after" onClick={_saveAfter}>{settings.btnCancel}</a>}
    </div>
};

UpdatePhone.propTypes = {
    phone: PropTypes.string,
    callbackServices: PropTypes.func,
    settings: PropTypes.object,
};

export default UpdatePhone;
